export class ParameterCheckResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "parameterName",
            "baseName": "parameterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "parameterGroupName",
            "baseName": "parameterGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "currentValue",
            "baseName": "currentValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "requiredValue",
            "baseName": "requiredValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "unmeasured",
            "baseName": "unmeasured",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "pendingReboot",
            "baseName": "pendingReboot",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isMinimum",
            "baseName": "isMinimum",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ParameterCheckResult.attributeTypeMap;
    }
    constructor() {
    }
}
